import type { RouteRecordRaw } from 'vue-router';

// i18n co-locate theo màn (STORY-921): namespace = route name camelCase = `staffs`.
// Vite resolve pattern này theo chính file chứa nó, nên đổi tên folder là bundle đi theo.
const i18n = import.meta.glob<{ default: Record<string, unknown> }>('./i18n/*.ts');

export const staffsRoutes = {
  name: 'staffs',
  path: 'staffs',
  component: () => import('./Staffs.vue'),
  meta: { i18n },
} satisfies RouteRecordRaw;
